//#region src/assets/email-unread-variant.svg
var email_unread_variant_default = "" + new URL("email-unread-variant-IaPm61Xv.svg", import.meta.url).href;
//#endregion
export { email_unread_variant_default as default };

//# sourceMappingURL=email-unread-variant.js.map